export default {
  'material.info': '我的信息',
  'material.collect': '我的收藏',
  'material.create': '我的创作',
  'material.unbind': '未绑定',
};
